document.addEventListener('DOMContentLoaded', () => {

  /* ---------- SP Menu ---------- */
  const spMenu = document.querySelector('.sp_menu');
  const gNav = document.querySelector('.g_nav');

  if (spMenu && gNav) {
    spMenu.addEventListener('click', () => {
      spMenu.classList.toggle('active');
      gNav.classList.toggle('open');
    });

    // ナビゲーション内のリンクをクリックしたらメニューを閉じる
    const navLinks = gNav.querySelectorAll('a');
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        spMenu.classList.remove('active');
        gNav.classList.remove('open');
      });
    });
  }

  /* ---------- Page Top ---------- */
  const pageTop = document.querySelector('.page_top');

  if (pageTop) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > window.innerHeight) {
        pageTop.classList.add('is-show');
      } else {
        pageTop.classList.remove('is-show');
      }
    });
  }

  /* ---------- Anchor Link Scroll ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const href = this.getAttribute('href');
      const targetId = href.replace(/^#/, '');

      if (!targetId) {
        // href="#" または href="" の場合はページトップへ
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        return;
      }

      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

});

/* ---------- header back-ground color change ---------- */
window.addEventListener('scroll', function() {
  const header = document.querySelector('header');
  if (window.scrollY >= window.innerHeight * 0.7) {
    header.classList.add('add_color');
  } else {
    header.classList.remove('add_color');
  }
});

/* ---------- sticky menu color change ---------- */
const items = document.querySelectorAll('.text_box .item');
const menuLinks = document.querySelectorAll('.list_area li');

window.addEventListener('scroll', () => {
  const triggerPoint = window.innerHeight * 0.5; // 画面の上から40%の位置

  items.forEach(item => {
    const rect = item.getBoundingClientRect();
    const id = item.id;

    // itemがtriggerPointを越えたか判定
    if (rect.top <= triggerPoint && rect.bottom > triggerPoint) {
      // liを全てリセットしてからactiveを付与
      menuLinks.forEach(li => li.classList.remove('active'));
      const activeLi = document.querySelector(`.list_area li.${id}`);
      if(activeLi) activeLi.classList.add('active');
    }
  });
});